module.exports = __webpack_public_path__ + "static/media/290778.77dcc1fd.png";